import styles from './Badge.module.scss'

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'destructive'

export const Badge = ({ tone = 'neutral', children }: { tone?: BadgeTone; children: React.ReactNode }) => (
  <span className={`${styles.badge} ${styles[tone]}`}>{children}</span>
)
